
/* ===== 전체 플로우 재배치 + 신규 화면 (KRDS) =====
   순서: HOME → 동의 → 정보입력 → AI대화 → Big5 → RIASEC → 완료 → 결과 → 상세
   근거: 서비스 이해 후 동의(informed consent) → 수집 직전 동의(개인정보보호법)
         라포 형성 먼저(이탈↓·솔직도↑) → 민감검사는 선택·후반 배치
*/
(function(){
  var PIA=window.PIA;

  /* ---------- [신규] 동의 화면 ---------- */
  var CONSENT_ITEMS=[
    {id:'c-privacy',t:'개인정보 수집·이용 동의',
     d:'수집 항목: 이름(또는 별명), 학년, 학교/기관, 검사 응답·결과<br>이용 목적: 검사 결과 분석·제공<br>보유 기간: 동의 철회 또는 목적 달성 시까지'},
    {id:'c-sensitive',t:'민감정보(정서 확인) 처리 동의',
     d:'정서 확인(CES-D·PHQ-A·GAD-7)은 <b>선택 검사</b>이며, 하지 않아도 됩니다. 의료 진단이 아닙니다.'},
    {id:'c-minor',t:'연령·법정대리인 확인',
     d:'만 14세 이상이거나, 만 14세 미만인 경우 법정대리인의 동의를 받았습니다.'},
    {id:'c-terms',t:'이용약관 동의',
     d:'본 서비스는 교육·자기이해 목적이며 의료 진단·치료를 대체하지 않습니다.'},
    {id:'c-safety',t:'안전 안내 동의',
     d:'대화 중 위기 신호가 감지되면 1388·109 등 상담 연락처를 화면에 안내합니다.'}
  ];
  /* [2026-10-01 OWNER '동의는 테스트 전에 다 일괄로 받아'] 카메라 동의도 이 화면에서 함께 받는다(선택 항목).
     체크하면 AI 대화 화면에서 동의 창 없이 카메라가 켜지고, 체크하지 않으면 켜지지 않는다.
     키오스크·pia_cam='0' 에서는 카메라를 쓰지 않으므로 항목을 보이지 않는다. */
  var CAM_ITEM={id:'c-camera',t:'카메라 표정 참고 동의',
     d:'AI와 대화하는 동안 카메라로 웃음·시선·졸림 같은 표정 신호를 <b>이 기기 안에서만</b> 읽어 대화 말투와 속도를 맞춰요. '
      +'얼굴 영상은 저장하거나 서버로 보내지 않고, 검사 결과에도 쓰지 않아요. 졸려 보이면 쉬어 가자고 권할 수 있어요. '
      +'대화 중 화면 구석의 [끄기]·[동의 취소]로 언제든 멈출 수 있어요. 만 14세 미만은 법정대리인(또는 담임 선생님)의 동의가 필요해요.'};
  function camItemOn(){
    try{
      if(document.documentElement.classList.contains('kiosk-on')) return false;
      if(localStorage.getItem('pia_cam')==='0') return false;
      return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
    }catch(e){ return false; }
  }
  window.piaRenderConsent=function(){
    var rows=CONSENT_ITEMS.map(function(c){
      return '<div class="pia-consent__row"><label class="pia-check" for="'+c.id+'">'
        +'<input type="checkbox" id="'+c.id+'" data-act-change="piaConsentSync">'
        +'<span class="pia-check__box" aria-hidden="true"></span>'
        +'<span class="pia-check__tx"><b>[필수] '+c.t+'</b></span></label>'
        +'<details class="pia-consent__more"><summary>자세히 보기</summary><div>'+c.d+'</div></details></div>';
    }).join('');
    if(camItemOn()){
      rows += '<div class="pia-consent__row"><label class="pia-check" for="'+CAM_ITEM.id+'">'
        +'<input type="checkbox" id="'+CAM_ITEM.id+'" data-act-change="piaConsentSync">'
        +'<span class="pia-check__box" aria-hidden="true"></span>'
        +'<span class="pia-check__tx"><b>[선택] '+CAM_ITEM.t+'</b></span></label>'
        +'<details class="pia-consent__more"><summary>자세히 보기</summary><div>'+CAM_ITEM.d+'</div></details></div>';
    }
    return '<div class="pia">'
      + PIA.back('홈',"showView('home')")
      + '<h2 class="pia-h1" style="margin-bottom:var(--pia-s2)">검사를 시작하기 전에<br>동의가 필요해요</h2>'
      + '<p class="pia-bodyL pia-muted" style="margin-bottom:var(--pia-s5)">아래 항목에 동의하시면 검사를 시작할 수 있어요.</p>'
      + '<div class="pia-setup__steps">'
      + '<div class="pia-ss"><span class="pia-ss__n" style="background:#246BEB;color:#fff">1</span><span class="pia-ss__l" style="color:#1D56BC">동의</span></div>'
      + '<span class="pia-ss__line"></span>'
      + '<div class="pia-ss"><span class="pia-ss__n" style="background:#F4F5F6;color:#636D76">2</span><span class="pia-ss__l" style="color:#636D76">정보 입력</span></div>'
      + '<span class="pia-ss__line"></span>'
      + '<div class="pia-ss"><span class="pia-ss__n" style="background:#F4F5F6;color:#636D76">3</span><span class="pia-ss__l" style="color:#636D76">검사 진행</span></div>'
      + '</div>'
      + '<section class="pia-sec pia-sec--qa">'
      + '<label class="pia-check pia-check--all" for="c-all"><input type="checkbox" id="c-all" data-act-change="piaConsentAll" data-arg-self>'
      + '<span class="pia-check__box" aria-hidden="true"></span><span class="pia-check__tx"><b>전체 동의하기</b></span></label>'
      + '<div class="pia-consent__list">'+rows+'</div>'
      + '<p class="pia-note" style="margin-top:var(--pia-s3)">'+PIA.icon('shield')+'동의하지 않을 권리가 있습니다. 다만 필수 항목에 동의하지 않으면 검사를 진행할 수 없어요.</p>'
      + '<div style="margin-top:var(--pia-s4)" id="pia-consent-cta">'
      + PIA.btn('동의하고 계속하기','piaConsentDone()','primary',{cta:1,arrow:1,disabled:true})
      + '</div></section></div>';
  };
  window.piaConsentSync=function(){
    var ids=CONSENT_ITEMS.map(function(c){return c.id;});
    var ok=ids.every(function(i){var e=document.getElementById(i);return e&&e.checked;});
    var cam=document.getElementById(CAM_ITEM.id);
    var all=document.getElementById('c-all'); if(all) all.checked=ok && (!cam || cam.checked);
    var w=document.getElementById('pia-consent-cta');
    if(w) w.innerHTML=PIA.btn('동의하고 계속하기','piaConsentDone()','primary',{cta:1,arrow:1,disabled:!ok});
  };
  window.piaConsentAll=function(cb){
    CONSENT_ITEMS.concat([CAM_ITEM]).forEach(function(c){var e=document.getElementById(c.id); if(e) e.checked=cb.checked;});
    piaConsentSync();
  };
  window.piaConsentDone=function(){
    try{
      var camEl=document.getElementById(CAM_ITEM.id), camOk=!!(camEl && camEl.checked);
      var rec={ at:new Date().toISOString(), items:CONSENT_ITEMS.map(function(c){return c.id;}).concat(camOk?[CAM_ITEM.id]:[]), v:'v2' };
      /* 카메라: 이 화면의 선택이 이번 검사의 결정 — 체크하면 동의 기록(pia-camera.js 가 읽음), 안 하면 지움 */
      if(camEl){
        if(camOk){ localStorage.setItem('pia_cam_consent_v2', JSON.stringify({ at: rec.at, v: 2, via: 'consent-screen' })); localStorage.removeItem('pia_cam_declined_at'); }
        else { localStorage.removeItem('pia_cam_consent_v2'); }
      }
      sessionStorage.setItem('pia_v3_consent','1');
      localStorage.setItem('pia_consent', JSON.stringify(rec));
      if(typeof _piaEnsureSB==='function'){
        _piaEnsureSB().then(function(sb){ if(sb&&sb.rpc){ try{ sb.rpc('pia_log_consent',{payload:rec}); }catch(e){} } });
      }
    }catch(e){}
    showView('setup');
  };

  /* ---------- [신규] 필수검사 완료 ---------- */
  window.piaRenderDone=function(){
    var b={}; (window._piaCards||[]).forEach(function(c){b[c.id]=c;});
    var names={chat:'AI와 대화',big5:'나의 성격',riasec:'진로 흥미'};
    var rows=['chat','big5','riasec'].map(function(id){
      var dn=b[id]&&window._piaIsDone?window._piaIsDone(b[id]):false;
      return '<li class="pia-done__i"><span class="pia-done__ck" style="background:'+(dn?'#EAFBE6':'#F4F5F6')
        +';color:'+(dn?'#128700':'#9AA5B4')+'">'+(dn?'✓':'·')+'</span>'+names[id]+'</li>';
    }).join('');
    return '<div class="pia" style="text-align:center;padding-top:var(--pia-s8)">'
      + '<div style="width:200px;margin:0 auto var(--pia-s4)" aria-hidden="true">'+PIA.botImg('wave','')+'</div>'
      + '<h2 class="pia-h1">필수 검사를<br>모두 완료했어요!</h2>'
      + '<p class="pia-bodyL pia-muted" style="margin:var(--pia-s3) 0 var(--pia-s5)">이제 통합 결과를 확인할 수 있어요.</p>'
      + '<ul class="pia-done__list">'+rows+'</ul>'
      + '<div style="margin-top:var(--pia-s5)">'
      + PIA.btn('통합 결과 확인하기',"showView('result')",'primary',{cta:1,arrow:1})
      + '<div style="height:var(--pia-s2)"></div>'
      + PIA.btn('선택 검사 더 해보기',"showView('home')",'secondary')
      + '</div></div>';
  };

  /* ---------- [신규] 마음건강 진입 안내 ---------- */
  var MIND=['rses','cesd','phqa','gad','who5'];
  window.piaRenderMindIntro=function(target){
    return '<div class="pia">'
      + PIA.back('홈',"showView('home')")
      + '<h2 class="pia-h1" style="margin-bottom:var(--pia-s3)">마음 건강 확인</h2>'
      + '<section class="pia-sec pia-sec--qa">'
      + '<p class="pia-bodyL" style="margin-bottom:var(--pia-s3)">요즘 마음이 어떤지 살펴보는 검사예요.</p>'
      + '<ul class="pia-ul">'
      + '<li>이 검사는 <b>선택</b>이에요. 하지 않아도 괜찮아요.</li>'
      + '<li>결과는 <b>의료 진단이 아니에요.</b> 참고용이에요.</li>'
      + '<li>답한 내용은 성격·진로 결과와 <b>합산하지 않아요.</b></li>'
      + '<li>언제든 그만둘 수 있어요.</li>'
      + '</ul>'
      + '<p class="pia-note" style="margin-top:var(--pia-s3)">'+PIA.icon('help')
      + '많이 힘들다면 언제든 1388(청소년) · 109(자살예방)로 연락할 수 있어요.</p>'
      + '<div style="margin-top:var(--pia-s4)">'
      + PIA.btn('시작하기',"showView('"+(target||'rses')+"')",'primary',{cta:1,arrow:1})
      + '<div style="height:var(--pia-s2)"></div>'
      + PIA.btn('다음에 할게요',"showView('home')",'secondary')
      + '</div></section></div>';
  };
  window.piaGoMind=function(t){ window._piaMindTarget=t||'rses'; showView('mindintro'); };
  window._piaMindTests=MIND;
})();

